export default ({ response, message, errors = [] }) => {
  const { status } = response;
  const errorMessage = message || status;
  const error = new Error(errorMessage);
  error.status = status;
  error.errors = errors;
  throw error;
};
